import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";

export default function VideoPlayer(props) {
  const { stopVideo } = props;
  const ref = useRef();
  const [playing, setPlaying] = useState(true);
  const [controlState, setControlState] = useState(false);

  useEffect(() => {
    ref.current.onplay = () => {
      setPlaying(true);
    };
    ref.current.onended = () => {
      ref.current?.play();
    };
  }, [ref]);

  useEffect(() => {
    if (stopVideo) {
      ref.current?.pause();
      ref.current.currentTime = 0;
    } else ref.current?.play();
  }, [stopVideo]);

  const handleKeyPress = (e) => {
    if (e.code === "Space") {
      if (controlState) {
        ref.current?.play();
      } else {
        ref.current?.pause();
      }
      setControlState(!controlState);
    }
  };
  useEffect(() => {
    if (props?.controlsVideo) {
      document.addEventListener("keydown", handleKeyPress);
    }
  }, [ref, controlState]);

  return (
    <div className={styles.root}>
      <video
        ref={ref}
        src={props?.src}
        poster={props?.img}
        // muted="muted"
        webkit-playsinline="true"
        playsInline
        preload="metadata"
      />
      {!playing && (
        <div className={styles.play} onClick={() => ref.current?.play()} />
      )}
    </div>
  );
}
